import React, { FC, useState, useEffect, useMemo } from 'react'
import { Box, Text, Grid, VStack, HStack, Flex, Image } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
import { selectScenario, selectCurrentStep, selectAnswers } from '../../state'
import { useTranslation } from 'react-i18next'
import { cardImageMap, Steps } from '../../state/interfaces'
import { getCookie } from '../../scenarios'

export interface LeadPlanProps {
  grandImage?: string
}

export const LeadPlanInfo: FC<LeadPlanProps> = ({ grandImage }) => {
  const scenario = useSelector(selectScenario)
  const currentStep = useSelector(selectCurrentStep)
  const { t } = useTranslation()
  const answers = useSelector(selectAnswers)
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])
  const [scenarioNavType, setScenarioNavType] = useState('mobile')

  useEffect(() => {
    if (scenario?.initialInformation?.nav === 'mobile') {
      setScenarioNavType('mobile')
    } else if (scenario?.initialInformation?.nav === 'internet') {
      setScenarioNavType('internet')
    }
  }, [])

  return (
    <VStack>
      <Box
        minWidth={{ base: '100%', md: '600px' }}
        padding={4}
        border={2}
        borderStyle="solid"
        borderColor="grey"
        borderRadius="xl"
        margin={4}
        boxShadow="lg"
      >
        <Flex>
          {image && (
            <Flex alignItems="center">
              <Image src={image} alt="image" width={['0', '150px']} height={['0', '150px']} />
            </Flex>
          )}
          <Box flexGrow={1}>
            <HStack justifyContent="center">
              <Text fontSize="sm" fontWeight="900" color="green.200" marginLeft={6}>
                {getCookie('providerName')} Plan:
              </Text>
              <Text fontSize="sm" color="green.500" marginLeft={6}>
                {scenario?.initialInformation?.planName || 'Undefined'}
              </Text>
            </HStack>

            <Box paddingX={{ base: '10%', md: '20%' }} paddingY={4} fontSize={{ base: 'xxs', md: 'lg' }}>
              <Grid templateColumns="repeat(2, auto)" gap={2}>
                {scenarioNavType === 'internet' ? (
                  <>
                    <Box>{t('download-speed')}:</Box>
                    <Box textAlign="right" fontWeight="bold">
                      {scenario?.initialInformation?.downloadSpeed || 'Undefined'}
                      {t('common_mbps')}
                    </Box>
                    <Box>{t('monthly-data-usage')}:</Box>
                    <Box textAlign="right" fontWeight="bold">
                      {scenario?.initialInformation?.planDataUsage || 'Undefined'}
                    </Box>
                  </>
                ) : (
                  <>
                    <Box>{t('voice_amount')}:</Box>
                    <Box textAlign="right" fontWeight="bold">
                      {scenario?.initialInformation?.sr_voice || 'Undefined'}
                    </Box>
                    <Box>{t('data_amount')}:</Box>
                    <Box textAlign="right" fontWeight="bold">
                      {scenario?.initialInformation?.sr_data?.replace(/[ \n]+/g, ' ') || 'Undefined'}
                    </Box>
                  </>
                )}
                <Box>{t('upfront')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.planUpfrontPrice || 'Undefined'}
                </Box>
                <Box>{t('monthly')}:</Box>
                <Box textAlign="right" fontWeight="bold">
                  {scenario?.initialInformation?.planMonthlyPrice || 'Undefined'}
                </Box>
              </Grid>
            </Box>
          </Box>
        </Flex>
      </Box>
      {currentStep!.id === Steps.CONFIRM_LEAD && (
        <Box>
          <Text fontWeight="900">
            {answers!['first-name']![0]} {answers!['last-name']}
          </Text>
          <Text>{answers!['address-location']![0]}</Text>
          <Text>{answers!['email-address-lead']![0]}</Text>
          <Text>{answers!['phone-number']![0]}</Text>
        </Box>
      )}
    </VStack>
  )
}
